import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {BrowserRouter as Router, Route, Switch, useParams, HashRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import Home from './Pages/Home';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Myaccount from './Pages/Myaccount';
import Aboutus from './Pages/Aboutus';
import Productdetails from './Pages/Productdetails';
import Contactus from './Pages/Contactus';
import Checkout from './Pages/Checkout';
import Wallet from './Pages/Wallet';
import Loginregister from './Pages/Loginregister';
import Shoplist from './Pages/Shoplist';
import Blogdetails from './Pages/Blogdetails';
import Myprofile from './Pages/Myprofile';
import Wallettrans from './Pages/Wallettrans';
import Address from './Pop-up/Address';
import Signup from './Pop-up/Signup';
import Signup2 from './Pop-up/Signup2';
import Register from './Pop-up/Register';
import OTPCheck from './Pop-up/OTPCheck';
import Myprofileaddress from './Pop-up/Myprofileaddress';
import Complaintitem from './Pop-up/Complaintitem';
import Complaint from './Pop-up/Complaint';
import Refer from './Pop-up/Refer';
import Referafriend from './Pop-up/Referafriend';

ReactDOM.render(
  <React.StrictMode>
      <Router >
        <Header />
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/index">
              <Home />
            </Route>
            <Route exact path="/index.html">
              <Home />
            </Route>
            <Route exact path="/shop-list">
              <Shoplist />
            </Route>
            <Route exact path="/my-account">
              <Myaccount />
            </Route>
            <Route exact path="/contact-us">
              <Contactus />
            </Route>
            <Route exact path="/blog-details">
              <Blogdetails />
            </Route>
            <Route exact path="/my-profile">
              <Myprofile />
            </Route>
            <Route exact path="/checkout">
              <Checkout />
            </Route>
            <Route exact path="/wallet">
              <Wallet />
            </Route>
            <Route exact path="/wallet-trans">
              <Wallettrans />
            </Route>
            <Route exact path="/complaint">
              <Complaint/>
            </Route>
            <Route exact path="/address">
              <Address />
            </Route>
            <Route exact path="/sign-up">
              <Signup/>
            </Route>
            <Route exact path="/sign-fup2">
              <Signup2 />
            </Route>
            <Route exact path="/register">
              <Register />
            </Route>
            <Route exact path="/otp-check">
              <OTPCheck />
            </Route>
            <Route exact path="/refer">
              <Refer />
            </Route>
            <Route exact path="/profile-address">
              <Myprofileaddress />
            </Route>
            <Route exact path="/complaint-item">
              <Complaintitem />
            </Route>
            <Route exact path="/refer-friend">
              <Referafriend />
            </Route>
            <Route exact path="/login-register">
              <Loginregister/>
            </Route>
            <Route exact path="/about-us">
              <Aboutus head="About" url="about-us" />
            </Route>
            <Route exact path="/privacy-policy">
              <Aboutus head="Privacy Policy"  url="privacy-policy"  />
            </Route>
            <Route exact path="/terms-conditions">
              <Aboutus head="Terms & Conditions"  url="terms-conditions"  />
            </Route>
            <Route exact path="/our-stores">
              <Aboutus head="Our Stores" url="our-stores" />
            </Route>
            <Route exact path="/order-tracking">
              <Aboutus head="Order Tracking" url="order-tracking" />
            </Route>
            <Route exact path="/product-details/:slug1">
              <Productdetails/>
            </Route>
          </Switch>
        <Footer />
      </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
